export default __webpack_public_path__ + "static/media/portfolio-madrid-5.d5815e7d.jpg";